export const IDS_TRAZABILITY_FLOW_ADVALTECH_PROD = [77, 201];
export const IDS_TRAZABILITY_FLOW_ADVALTECH_TEST = [4];
export const IDS_TRAZABILITY_FLOW_ADVALTECH_DEV = [4];
export const IDS_SCANER_TIME = [160];
export const IDS_COMPANY_CREATE_TRAZABILITY_AND_PRODUCTIVITY = [
  154, 5, 179, 160, 152
];

export const IDS_TRAZABILITY_FLOW_BAFAR_PROD = [164];
export const IDS_TRAZABILITY_FLOW_BAFAR_TEST = [3, 152];
export const IDS_TRAZABILITY_FLOW_BAFAR_DEV = [3, 1, 152, 164];

// company develop ID = 152
